// Enum for type of icon
export enum IconType {
  ContractorWork = 'ContractorWork',
  RiskAssessment = 'RiskAssessment',
  Inspection = 'Inspection',
  BBSO = 'BBSO',
  Incident = 'Incident',
  GMPAudit = 'GMPAudit',
  LocationPoint = 'LocationPoint'
}

// Mapping between icon type and corresponding icon file path
export const IconPath: { [iconType in IconType]: string } = {
  [IconType.ContractorWork]: 'assets/icon/floor-plan/contractor-work.svg',
  [IconType.RiskAssessment]: 'assets/icon/floor-plan/exclamation-alert.svg',
  [IconType.Inspection]: 'assets/icon/floor-plan/inspection.svg',
  [IconType.BBSO]: 'assets/icon/floor-plan/observation.svg',
  [IconType.Incident]: 'assets/icon/floor-plan/accident.svg',
  [IconType.GMPAudit]: 'assets/icon/floor-plan/audit.svg',
  [IconType.LocationPoint]: 'assets/icon/floor-plan/location-point.svg'
}